module.exports = __webpack_public_path__ + "static/c4-eb338528c2526376b08ce82a3bb5e99e.jpg";